import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Context from '../../../../legacy/src/components/questionBank/QuizBuilder/state/context';

const withQbPreviewData = (WrapperComponent) => {
  const BlueBookQbPreviewData = (props) => {
    const itemsData = props.itemsData || {};
    const params = props.params || {};
    const loadMoreFF = props.loadMoreFF || false;

    let previewData = {};

    const [{ activeStimulusFilters, allStimulusQuestions }] =
      useContext(Context);

    if (activeStimulusFilters?.length > 0) {
      let items = [];
      Object.keys(allStimulusQuestions).map((stimulus) => {
        let newItems = [];
        if (activeStimulusFilters.includes(stimulus)) {
          newItems = allStimulusQuestions[stimulus];
        }
        items = items.concat(newItems);
      });
      items.sort((a, b) => a.title.localeCompare(b.title));

      previewData = {
        itemId: params.previewId,
        items,
        itemsPerPage: items.length,
        currentPage: 0,
        total: items.length,
        hasMorePages: false,
        pathname: '/question_bank/questions/',
        loadMoreFF,
      };
    } else {
      previewData = {
        itemId: params.previewId,
        items: itemsData.items || [],
        itemsPerPage: itemsData.per_page || 0,
        currentPage: itemsData.current_page || 0,
        total: itemsData.total || 0,
        hasMorePages: itemsData.has_more,
        pathname: '/question_bank/questions/',
        loadMoreFF,
      };
    }

    return <WrapperComponent {...props} previewData={previewData} />;
  };

  return BlueBookQbPreviewData;
};

const mapStateToProps = (state) => ({
  itemsData: state?.assessment?.itemsData,
  loadMoreFF: state.featureFlag.ap_qb_preview_load_more,
});

export default compose(connect(mapStateToProps), withQbPreviewData);
